import { Outlet } from "react-router";
import styled from "styled-components";
import { useAuth } from "./context/AuthContext";
import { getCompanyPhoto } from "./api/companyApi";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";

function App() {
  const { company, logout } = useAuth();
  const [companyLogo, setCompanyLogo] = useState<any>();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const getPhoto = async (photoId: string | null, type: string) => {
    try {
      if (!photoId) return;
      const response: any = await getCompanyPhoto(photoId, type);
      const imgUrl = URL.createObjectURL(response.data);
      setCompanyLogo(imgUrl);
    } catch (error) {
      console.error(`Fetch error for ${type}:`, error);
    } finally {
    }
  };

  useEffect(() => {
    getPhoto(company?.hrPhoto, "hr");
    // eslint-disable-next-line
  }, [company]);

  return (
    <AppWrapper>
      <Sidebar
        sidebarOpen={sidebarOpen}
        companyLogo={companyLogo}
        onLogoutClick={logout}
      />

      <ContentWrapper>
        <Navbar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          companyLogo={companyLogo}  
        />
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </AppWrapper>
  );
}

export default App;

const AppWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;

const MainContent = styled.main`
  flex-grow: 1;
  background: #f0f0f5;
  overflow-y: auto;
  
`;